//Those routes should only be used for frontend routes
export const LOGIN_ROUTE = "login";
export const DOCUMENT_ROUTE = "documents";
export const RAPPORT_ROUTE = "rapports";
export const DOCUMNET_SETTINGS_ROUTE = "settings";
export const POSITION_ROUTE = "position";
export const EXTENT_ROUTE = "extent";
